/* global $:false */

export default class PaymentPending {
  static init () {
    this.checkUrl = $('[data-payment-pending-check-url]').attr('data-payment-pending-check-url')
    if (!this.checkUrl) { return }
    this.poll()
  }

  static poll () {
    setInterval(() => {
      this.check()
    }
    , 5000)
  }

  static check () {
    $.ajax({ url: this.checkUrl }).done(function (data) {
      if (data.redirect_to) {
        window.location.href = data.redirect_to
      }
    })
  }
}
